<app-dialog-header
  [title]="data?.title"
  [dialogRef]="dialogRef"
  (close)="onCancel()"
></app-dialog-header>

<mat-dialog-content>
  <kpi4me-text-element
    [formControlElement]="this.reason"
    [inputType]="inputType"
    [hideLabel]="true"
    [patternErrorMessage]="'Bitte geben Sie eine gültige Dezimalzahl ein.'"
  />
</mat-dialog-content>

<div mat-dialog-actions style="margin-top:1rem;">
  <app-confirm-icon-button [disabled]="!form()?.formControlElement?.valid" (customClick)="onConfirm()"/>
</div>
